import { Grid } from "@mui/material";
import * as React from "react";
import {
  Create,
  ReferenceInput,
  SelectInput,
  TextInput,
  BooleanInput,
  DateTimeInput,
  required,
  AutocompleteInput
} from "react-admin";
import { StatusEnum, PrivacyEnum } from "src/common/enum";
import Transformer from "src/common/Transformer";
import { FileInput } from "src/components/file-input";
import { TinyMCEContentInput } from "../../components/input";
import { ArticleCreateComponent } from "./ArticleComponent";
import { FormTab, TabbedForm } from "src/enterprise/ra-rbac";
export const ArticleCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["published_at"],
      update: {
        author: data.author.id,
        publishedAt: data["published_at"],
        featured: data.featured !== null ? data.featured.toString() : "false",
      },
    });
    return data;
  };

  return (
    <Create transform={transform} component={ArticleCreateComponent}>
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <BooleanInput
                label="Featured"
                source="featured"
                options={undefined}
              />
            </Grid>
          </Grid>

          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} md={6} lg={4}>
              <TextInput source="title" validate={required()} />
            </Grid>

            <Grid item lg={4}>
              <ReferenceInput
                source="author.id"
                reference="admin/users"
                filter={{ "roles.like": "ROLE_ADMIN" }}
                
              >
                <AutocompleteInput
                  optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                  size="small"
                  label="Author"
                  validate={required()}
                />
              </ReferenceInput>
            </Grid>
            <Grid item lg={4}>
              <DateTimeInput label="Published at" source="published_at" />
            </Grid>
            <Grid item lg={4}>
              <SelectInput source="status" choices={StatusEnum} validate={required()}/>
            </Grid>
            <Grid item lg={4}>
              <SelectInput source="privacy" choices={PrivacyEnum} validate={required()}/>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item md={12}>
              <TinyMCEContentInput source="content" required base64 fullWidth />
            </Grid>
            <Grid item md={12}>
              <TinyMCEContentInput source="excerpt" required base64 fullWidth />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="SEO" name="seo">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_title" />
            </Grid>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_description" multiline rows={4} />
            </Grid>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_keywords" multiline rows={4} />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Featured Image" name="image">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <FileInput
                source="image"
                fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
                multiple={false}
              />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Custom CSS" name="css">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={12}>
              <TextInput source="css" multiline fullWidth minRows="15" maxRows="30"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
